import { updateBundleItem } from "../../api/inventoryService";

export const useUpdateBundleItem = (successCallback) => {
  const update = async (id, data) => {
    try {
        const updatedRecord = await updateBundleItem(id, data);
        if (successCallback) successCallback(updatedRecord);
        return updatedRecord;
    } catch (error) {
        console.error("Failed to update bundle item:", error);
        throw error;
    }
  };

  return { update };
};